export default __webpack_public_path__ + "static/media/instaladorAcre.17a1d5e2.png";